/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface POIPublic { 
    Name: string;
    Id: string;
    X: number;
    Y: number;
    Width: number;
    Height: number;
    CreatedBy: string;
    CreationDate: string;
    LastEdit: string | null;
    LastEditBy: string | null;
}

